import { GBClientProvider } from "@platform/feature-flags/client";
import { featureFlagAttributesFor } from "@platform/user";
import { useUser } from "@platform/user/client";

import envVariables from "../projectEnvVariables";

import type { ReactNode } from "react";

interface GrowthBookEnvVariables {
  readonly VITE_REACT_APP_GROWTHBOOK_API_HOST?: string;
  readonly VITE_REACT_APP_GROWTHBOOK_CLIENT_KEY?: string;
}

// projectEnvVariables.js is untyped JavaScript; these are the only values read here.
const growthBookEnv = envVariables as GrowthBookEnvVariables;

// In dev mode, VITE_FORCE_FLAGS can be a comma-separated list of GrowthBook
// feature flag keys to force on (e.g. "consultant-view,some-other-flag").
const forcedFlags: readonly string[] =
  import.meta.env.DEV && import.meta.env.VITE_FORCE_FLAGS
    ? String(import.meta.env.VITE_FORCE_FLAGS)
        .split(",")
        .map((flag) => flag.trim())
        .filter(Boolean)
    : [];

/**
 * GrowthBook for bpfe, targeted at the signed-in user. Sits below the user lib's
 * UserProvider so the user's attributes are available when flags are evaluated.
 */
const UserFeatureFlagsProvider = ({
  children,
}: {
  children: ReactNode;
}): ReactNode => {
  const { user } = useUser();
  const attributes =
    user.status === "signedIn" ? featureFlagAttributesFor(user) : undefined;

  return (
    <GBClientProvider
      apiHost={growthBookEnv.VITE_REACT_APP_GROWTHBOOK_API_HOST}
      clientKey={growthBookEnv.VITE_REACT_APP_GROWTHBOOK_CLIENT_KEY}
      forcedFlags={forcedFlags}
      attributes={attributes}
    >
      {children}
    </GBClientProvider>
  );
};

export default UserFeatureFlagsProvider;
